module.exports = __webpack_public_path__ + "img/Benin.39a327cc.gif";